import { resolveApiOrigin } from '@vipso/shared';

export type ProductsImportResult = {
  imported: number;
  parsed: number;
  createdIds: string[];
  errors: Array<{ row: number; message: string }>;
};

export async function downloadProductsImportTemplate(accessToken: string): Promise<void> {
  const apiUrl = resolveApiOrigin();
  if (!apiUrl) throw new Error('VITE_API_URL is not set');

  const res = await fetch(`${apiUrl}/api/import/template/products`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || 'Failed to download template');
  }

  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = 'vipso-products-import-template.xlsx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}

export async function importProductsExcel(
  file: File,
  accessToken: string,
): Promise<ProductsImportResult> {
  const apiUrl = resolveApiOrigin();
  if (!apiUrl) throw new Error('VITE_API_URL is not set');

  const formData = new FormData();
  formData.append('file', file, file.name);

  const res = await fetch(`${apiUrl}/api/import/products`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    body: formData,
  });

  const body = (await res.json().catch(() => ({}))) as ProductsImportResult & { error?: string };
  if (!res.ok) {
    throw new Error(body.error || 'Import failed');
  }
  return {
    imported: body.imported ?? 0,
    parsed: body.parsed ?? 0,
    createdIds: body.createdIds ?? [],
    errors: body.errors ?? [],
  };
}
